import React, { useEffect, useRef, useState } from "react";
import { checkIsOpen, getDistanceByUserLocation, getEventStartDate, getRating, getTodayHours } from "./placeUtils";
import settings, { saveSetting } from "./settings";
import { useLanguage } from "./LanguageContext";
import Breadcrumbs from "./Breadcrumbs";

function SortingPanel(props){
    const { t } = useLanguage();

    const resultsArray = [
        {value: 8, label: "8 wyników"}, 
        {value: 12, label: "12 wyników"}, 
        {value: 20, label: "20 wyników"}, 
        {value: 40, label: "40 wyników"}];

        const sortingArray = props.target === "event" ?
        [
        {value: 0, label: "↓ data dodania"},
        {value: 1, label: "↓ alfabetycznie"},
        {value: 2, label: "↓ wg. oceny"},
        {value: 3, label: "↓ wg. rozpoczęcia"},
        {value: 4, label: "↓ najbliższe"},
        ] : [
        {value: 0, label: "↓ data dodania"},
        {value: 1, label: "↓ alfabetycznie"},
        {value: 2, label: "↓ wg. oceny"},
        {value: 3, label: "↓ wg. otwarcia"},
        {value: 4, label: "↑ wg. otwarcia"},
        {value: 5, label: "↓ najbliższe"},
        ];
        const [sortingDropdown, setSortingDropdown] = useState(props.target === "event" ? sortingArray[settings.sortingByEvents].value 
        : sortingArray[settings.sortingByPlaces].value);
        const [soringImage, setSortingImage] = useState("/icons/grid-icon-black.png");
        const collectionKey = props.collection?.map((target) => target._id).join("|") ?? "";
        const sortedCollectionKeyRef = useRef("");

        useEffect(() => {
            if (props.collection?.length > 0 && collectionKey !== sortedCollectionKeyRef.current){
                sortPlaces(sortingArray[sortingDropdown].label);
            }
        }, [collectionKey]);
    
    function sortPlaces(sortBy){
        let targetsToSort = [...props.collection];

        if (sortBy === sortingArray[1].label){
            targetsToSort.sort(function(a,b){
                let x = a.title.toLowerCase();
                let y = b.title.toLowerCase();
            
                 if(x>y){return 1;} 
                 if(x<y){return -1;}
                 return 0;
               });

            // setSortDown(sortingArray[1].label);
        } else if (sortBy === sortingArray[0].label){
            targetsToSort.sort(function(a,b){
                if (a.created === undefined || a.created === ""){
                    return 1;
                }

                if (b.created === undefined || b.created === ""){
                    return -1;
                }

                let x = new Date(a.created);
                let y = new Date(b.created);
            
                 if(x>y){return 1;} 
                 if(x<y){return -1;}
                 return 0;
               });
        } else if (sortBy === sortingArray[2].label){
            targetsToSort.sort(function(a,b){
                if (a.commentsAndRatings === undefined  || a.reviews === "" || a.commentsAndRatings.length <= 0){
                    return 1;
                }

                if (b.commentsAndRatings === undefined || b.reviews === "" || b.commentsAndRatings.length <= 0){
                    return -1;
                }

                let x = getRating(a.commentsAndRatings, a.reviews);
                let y = getRating(b.commentsAndRatings, b.reviews);
            
                 if(x.finalRating>y.finalRating){return -1;} 
                 if(x.finalRating<y.finalRating){return 1;}
                 if (x.finalRating===y.finalRating){return x.votes > y.votes ? -1 : 1;}
                 return 0;
               });
        }

        if (props.target === "event"){
            if (sortBy === sortingArray[3].label){
                targetsToSort.sort(function(a,b){
                    let x = getEventStartDate(a);
                    let y = getEventStartDate(b);

                    if (!x || !y){
                        return !x && !y ? 0 : (x ? -1 : 1);
                    }

                    if (x.getDate() === y.getDate() && x.getMonth() === y.getMonth() && x.getFullYear() === y.getFullYear() ){
                        if (a.hours[0].open > b.hours[0].open){
                            return 1;
                        }
                        else {
                            return -1;
                        }
                    }
                
                     if(x>y){return 1;} 
                     if(x<y){return -1;}
                     return 0;
                   });
            } else if (sortBy === sortingArray[4].label){
                addDistanceToTargets(targetsToSort);

                targetsToSort.sort(function(a,b){
                    let x = a.distanceFromUser;
                    let y = b.distanceFromUser;
                    if (x>y){return 1;}
                    if (x<y){return -1;}
                    return 0;
                });
            }
        } else if (props.target === "place"){
            if (sortBy === sortingArray[3].label){
                targetsToSort.sort(function(a,b){
                    if (checkIsOpen(a) === false){
                        return 1;
                    };

                    if (checkIsOpen(b) === false){
                        return -1;
                    }
    
                    let x = getTodayHours(a);
                    let y = getTodayHours(b);
                
                     if(x.close.split(":")[0]>y.close.split(":")[0]){return -1;} 
                     if(x.close.split(":")[0]<y.close.split(":")[0]){return 1;}
                     if (x.close.split(":")[0]===y.close.split(":")[0]){return x.close.split(":")[1] > y.close.split(":")[1] ? -1 : 1;}
                     return 0;
                   });
            } else if (sortBy === sortingArray[4].label){
                targetsToSort.sort(function(a,b){
                    if (checkIsOpen(a) === false){
                        return 1;
                    };

                    if (checkIsOpen(b) === false){
                        return -1;
                    }
    
                    let x = getTodayHours(a);
                    let y = getTodayHours(b);
                
                     if(x.close.split(":")[0]>y.close.split(":")[0]){return 1;} 
                     if(x.close.split(":")[0]<y.close.split(":")[0]){return -1;}
                     if (x.close.split(":")[0]===y.close.split(":")[0]){return x.close.split(":")[1] > y.close.split(":")[1] ? -1 : 1;}
                     return 0;
                   });
            } else if (sortBy === sortingArray[5].label){
                addDistanceToTargets(targetsToSort);

                targetsToSort.sort(function(a,b){
                    let x = a.distanceFromUser;
                    let y = b.distanceFromUser;
                    if (x>y){return 1;}
                    if (x<y){return -1;}
                    return 0;
                });
            }
        }

            const sortedCollectionKey = targetsToSort.map((target) => target._id).join("|");
            sortedCollectionKeyRef.current = sortedCollectionKey;
            if (sortedCollectionKey !== collectionKey){
                props.setCollection(targetsToSort);
            }
         props.setIsSorted(true);
     }

     function setSortingDropdownWithSave(value){
        setSortingDropdown(value);
        switch (props.target) {
            case "event":
                saveSetting("sortingByEvents", value);
                break;
            case "place":
                saveSetting("sortingByPlaces", value);
            default:
                break;
        }
     }

    function addDistanceToTargets(targets){
        targets.forEach(element => {
            element.distanceFromUser = getDistanceByUserLocation(element.location);
        });
    }

    function sortingClick(value){
        setSortingDropdownWithSave(value);
        props.setPageNumber(0);
        sortPlaces(sortingArray[value].label);
    }

    function resultsClick(value){
        props.setPageNumber(0);
        props.setResultsOnPage(parseInt(value));
    }

    function cardsSizeClick(){
        setSortingImage(soringImage === "/icons/grid-icon-black.png" ? "/icons/list-icon.png" : "/icons/grid-icon-black.png")
        props.cardsSize();
    }

    const CustomDropdown = (dropdownProps) => {
        const { options, changePoint, label } = dropdownProps;
        return (
            <label className="sorting-control">
                <span>{label}</span>
                <select value={changePoint} onChange={(event) => dropdownProps.handleChange(Number(event.target.value))}>
                    {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
                </select>
            </label>
        );
      };

    return(
        <div className="sorting-panel">
        {props.collection !== undefined && props.collection.length > 0 ?
        <div className="sorting-panel-deck">
            <Breadcrumbs category={props.breadcrumbCategory} />

            <div className="sorting-panel-element">
            <CustomDropdown options={sortingArray} handleChange={sortingClick} changePoint={sortingDropdown} label={t("sortBy")} />
            </div>

            <div className="sorting-panel-element">
            <CustomDropdown options={resultsArray} handleChange={resultsClick} changePoint={props.resultsOnPage} label={t("resultsCount")} />
            </div>

            <div className="sorting-panel-element">
                <button type="button" className="changeSizeButton" onClick={cardsSizeClick} title={t("changeCardView")} aria-label={t("changeCardView")}><img src={soringImage} alt="" /></button>
            </div>
        </div>
        : null}
        </div>
    )
}

export default SortingPanel;
